import React, { useState,useEffect,useCallback ,useRef} from 'react';
import {
  useParams
} from "react-router-dom";
import { chatBot } from "../componets/botV2";
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'
import ReactStars from "react-rating-stars-component";
import { useCookies } from 'react-cookie';
import Select from 'react-select';
import GooglePlacesAutocomplete from 'react-google-places-autocomplete';
import { Widget } from "@uploadcare/react-widget";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import Loader from "react-loader-spinner";


import Slider from "react-slick";

//import Head from 'next/head';

const axios = require('axios');
/*

        keyboard:{type:'text',variable:'pollo',goTo:'6yw6ywyhd'},
        posizione:0,
        mess:[
            {
                testo:'ciao',jd:true
            },
            {
                testo:'bella di padella',jd:true
            },
            {
                testo:'ci provo io ',jd:false
            },
            {
                testo:'bettola ',jd:false
            }
        ]
    
*/
const scrollToRef = (ref) => window.scrollTo(0, ref.current.offsetTop)  

const schemaPerDev = { "connect": [], "boxmess": [ { "id": "inixioo", "multyB": false, "start": true, "defaultNext": "_ab7of27v6", "testi": [ { "type": "text", "img": null, "value": "<p>primo</p>", "raw": { "blocks": [ { "key": "9ib96", "text": "sdsdsd", "type": "unstyled", "depth": 0, "inlineStyleRanges": [], "entityRanges": [], "data": {} } ], "entityMap": {} } }, { "type": "text", "img": null, "value": "<p>secondo</p>", "raw": { "blocks": [ { "key": "9ib96", "text": "sdsdsd", "type": "unstyled", "depth": 0, "inlineStyleRanges": [], "entityRanges": [], "data": {} } ], "entityMap": {} } } ], "askType": "jm", "buttons": [ { "label": "1d", "goTo": "_uk1bwnzj3" }, { "label": "22", "goTo": "byby" } ], "posizione": { "x": 78, "y": 261 } }, { "fine": true, "id": "byebye", "multyB": false, "testi": [ { "type": "text", "img": null, "value": "pollo", "raw": { "entityMap": {}, "blocks": [] } } ], "askType": "jm", "buttons": [], "defaultNext": "after", "posizione": { "x": 1407, "y": 232 } }, { "id": "_ab7of27v6", "testi": [ { "type": "text", "img": null, "value": "<p>ciao questa è una prova di salvataggio!</p><p></p>", "raw": { "blocks": [ { "key": "3v8qo", "text": "ciao questa è una prova di salvataggio!", "type": "unstyled", "depth": 0, "inlineStyleRanges": [], "entityRanges": [], "data": {} }, { "key": "4dp1r", "text": "", "type": "unstyled", "depth": 0, "inlineStyleRanges": [], "entityRanges": [], "data": {} } ], "entityMap": {} } } ], "askType": "jm", "buttons": [], "multyB": false, "defaultNext": "_8cv2vcy4m", "posizione": { "x": 348, "y": 261 } }, { "id": "_kamvrpvhh", "testi": [ { "type": "text", "img": null, "value": "<p>Vogliamo provare la nuova funxione form?</p><p>😈</p>", "raw": { "blocks": [ { "key": "fk4ii", "text": "Vogliamo provare la nuova funxione form?", "type": "unstyled", "depth": 0, "inlineStyleRanges": [], "entityRanges": [], "data": {} }, { "key": "7og6t", "text": "😈", "type": "unstyled", "depth": 0, "inlineStyleRanges": [], "entityRanges": [], "data": {} } ], "entityMap": {} } } ], "askType": "frm", "buttons": [], "multyB": false, "defaultNext": "byebye", "posizione": { "x": 932, "y": 276 }, "formQuestions": [ { "label": "Nome", "type": "txt", "placeholder": "", "variabile": "" }, { "label": "Cognome", "type": "txt", "placeholder": "", "variabile": "" } ], "variabile": "test_form" }, { "id": "_8cv2vcy4m", "testi": [ { "type": "text", "img": null, "value": "<p>form yo</p>", "raw": { "blocks": [ { "key": "bama0", "text": "form yo", "type": "unstyled", "depth": 0, "inlineStyleRanges": [], "entityRanges": [], "data": {} } ], "entityMap": {} } }, { "type": "media", "value": "", "raw": { "entityMap": {}, "blocks": [] }, "url": "https://media.giphy.com/media/lSPlEENLTonvclZP44/giphy.gif" } ], "askType": "mc", "buttons": [ { "label": "si", "goTo": "_kamvrpvhh" }, { "label": "no", "goTo": "_aqg8qy3f9" } ], "multyB": false, "defaultNext": "byebye", "posizione": { "x": 593, "y": 228 } }, { "id": "_aqg8qy3f9", "testi": [ { "type": "text", "img": null, "value": "<p>hai click no</p>", "raw": { "blocks": [ { "key": "20p6q", "text": "hai click no", "type": "unstyled", "depth": 0, "inlineStyleRanges": [], "entityRanges": [], "data": {} } ], "entityMap": {} } }, { "type": "text", "img": null, "value": "<p>hai click no</p>", "raw": { "blocks": [ { "key": "20p6q", "text": "hai click no", "type": "unstyled", "depth": 0, "inlineStyleRanges": [], "entityRanges": [], "data": {} } ], "entityMap": {} } } ], "askType": "jm", "buttons": [], "multyB": false, "defaultNext": "byebye", "posizione": { "x": 933, "y": 503 } } ] }
const noop = () => {};

function Chat({ infoRoom, chatArr ,idResp ,imgProfilo ,posizioneF,rispIniziali}) {


    

    const myRef = useRef(null)
    const widgetApi = useRef();
    
    
    const [messages, setMessage] = useState([]);
    const [options, setOptions] = useState([]);
    const [dinamicSelect,setDinamicSelect] = useState([]);
    const [schemaRisposte,setSchemaRisp] = useState(rispIniziali ? rispIniziali : {});
    const [quetyons, setQuestions] = useState(null);
    const [risposta, setRisposta] = useState({});
    const [typing, setTyping] = useState(false);
    const [address, setAddress] = useState(null);
    const [restart,setRestart] = useState( posizioneF ? true :false)
    

    const [selected, setSelected] = useState(() => noop);
    const [restartx, setRestartx] = useState(() => noop);
    let { id } = useParams();



    

    const createArrayAutocomp = (testo) =>{
        let listaAutoc = []
        let arrays = testo.split("\n")

        arrays.forEach(element => {
        if(element && element !== ' ' ){
            listaAutoc.push({ value: element, label: element })
        }

        });
        return listaAutoc
    }


    const salvaPosizione = async (goto) =>{

        let obj = {}
        obj.posizione_flow = goto;

       let resppp = await axios.put(
            'https://rivolta-form.herokuapp.com/api/v1/responde/edit/'+idResp,
            obj
          );


    }

    const updateResponder = async (obj,goto) =>{

        
        obj.posizione_flow = goto;
       await axios.put(
            'https://rivolta-form.herokuapp.com/api/v1/responde/edit/'+idResp,
            obj
          );

          

    }

    const crateMessUser = (label,goTo) =>{
        let userMess = {
            value:label,
            my:true
        }

        setMessage(messages => [...messages, userMess])
        
        if(quetyons.variabile){
            let newSchema = {...schemaRisposte};
            newSchema[quetyons.variabile] = label
            setSchemaRisp(newSchema)
            updateResponder(newSchema,goTo)
            
        }

        selected(goTo)

    }

    const updateRispostaReating = (newRating) =>{
        
        let risposte = risposta
        risposte[quetyons.variabile] = newRating

        setRisposta(risposte)
        
    }

    const ripostaAutoCompUpdate = (value) =>{
        
        
        let risposte = {...risposta}
        
        
        risposte.autoCompFly = value ? value.value : null
        
        setRisposta(risposte)
    }

    const ripostaLocations= (value) =>{
        
        let risposte = {...risposta}
        
        risposte.locationsFly = value
        setRisposta(risposte)
    }

    const salvaLocation = () =>{

        let userMess = {
            value:risposta.locationsFly,
            my:true
        }

        setMessage(messages => [...messages, userMess])
        if(quetyons.variabile){
            
           let newSchema = {...schemaRisposte};
            newSchema[quetyons.variabile] = risposta.locationsFly
            setSchemaRisp(newSchema)
            updateResponder(newSchema,quetyons.defaultNext)
        }
        selected(quetyons.defaultNext)
    }

    const salvaEinvia = () =>{

        let userMess = {
            value:risposta.autoCompFly,
            my:true
        }

        setMessage(messages => [...messages, userMess])
        if(quetyons.variabile){
            
           let newSchema = {...schemaRisposte};
            newSchema[quetyons.variabile] = risposta.autoCompFly
            setSchemaRisp(newSchema)
            updateResponder(newSchema,quetyons.defaultNext)
        }
        selected(quetyons.defaultNext)
    }


    const salvaImgFile = (obj) =>{

       
        let userMess = {
            value:obj.cdnUrl,
            my:true,
            url:obj.cdnUrl,
            type:'media'
        }

        setMessage(messages => [...messages, userMess])
        if(quetyons.variabile){
            
           let newSchema = {...schemaRisposte};
            newSchema[quetyons.variabile] = obj.cdnUrl
            setSchemaRisp(newSchema)
            updateResponder(newSchema,quetyons.defaultNext)
        }
        selected(quetyons.defaultNext)
    }
    
   
    const updateRisposta = (input) =>{
        
        let chiave = input.target.name
        let risposte = risposta
        if(!risposte[quetyons.variabile]){
            risposte[quetyons.variabile] = {}
        }
        risposte[quetyons.variabile][chiave] = input.target.value
        setRisposta(risposte)
    }

    const updateRispostaSingolo = (valore) =>{
        
        let risposte = risposta
        risposte[quetyons.variabile] = valore

        setRisposta(risposte)
    }


    const salvaForm = () =>{
        let userMess = {
            value: 'form Inviato' ,
            my:true
        }
        setMessage(messages => [...messages, userMess])

        if(quetyons.variabile){
            let newSchema = {...schemaRisposte};
            newSchema[quetyons.variabile] = risposta[quetyons.variabile]
            setSchemaRisp(newSchema)
            updateResponder(newSchema,quetyons.defaultNext)
        }
        
        selected(quetyons.defaultNext)
    }

    const salvaRating = () =>{
        
        let userMess = {
            value: risposta[quetyons.variabile] ,
            my:true
        }

        setMessage(messages => [...messages, userMess])
        if(quetyons.variabile){
            let newSchema = {...schemaRisposte};
            newSchema[quetyons.variabile] = risposta[quetyons.variabile]
            setSchemaRisp(newSchema)
            updateResponder(newSchema,quetyons.defaultNext)
        }
        selected(quetyons.defaultNext)
    }
    const salvaText = (email) =>{
        const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

        let userMess = {
            value: risposta[quetyons.variabile].textValue ,
            my:true
        }
        if(email && !re.test(String(risposta[quetyons.variabile].textValue).toLowerCase()) ){
            let errorMess = {
                value: 'sembra che tu non abbia scritto la email nel formato corretto!' ,
                my:false
            }
            setMessage(messages => [...messages, userMess])
            setMessage(messages => [...messages, errorMess])
        }else{
            setMessage(messages => [...messages, userMess])
            selected(quetyons.defaultNext)
            if(quetyons.variabile){
                let newSchema = {...schemaRisposte};
                newSchema[quetyons.variabile] = risposta[quetyons.variabile].textValue
                setSchemaRisp(newSchema)
                updateResponder(newSchema,quetyons.defaultNext)
            }
        }
        
    }


    const salvaDinamycValue = () =>{
        let userMess = {
            value: 'ok' ,
            my:true
        }
       
        setMessage(messages => [...messages, userMess])
        /*if(quetyons.variabile){
            let newSchema = {...schemaRisposte};
            newSchema[quetyons.variabile] = risposta[quetyons.variabile]
            setSchemaRisp(newSchema)
            updateResponder(newSchema,quetyons.defaultNext)
        }*/
        
        selected(quetyons.defaultNext)
    }


    const salvaSingleValue = () =>{
        let userMess = {
            value: risposta[quetyons.variabile] ,
            my:true
        }
       
        setMessage(messages => [...messages, userMess])
        if(quetyons.variabile){
            let newSchema = {...schemaRisposte};
            newSchema[quetyons.variabile] = risposta[quetyons.variabile]
            setSchemaRisp(newSchema)
            updateResponder(newSchema,quetyons.defaultNext)
        }
        
        selected(quetyons.defaultNext)
    }


    useEffect(()=>{

        //alert(posizioneF)

        if(posizioneF){
            chatArr.push(
                {
                    askType: "mc",
                    id: "_restartB",
                    multyB: false,
                    testi:[
                      {
                        type: "text",
                        value: "<p>Ciao ben tornato!</p><p>vuoi continuare la vecchia conversazione oppure vuoi ricominciare?</p>"
                        }
                    ],
                    buttons:[
                      {goTo: "inixioo",
                      label: "Ricomincia"
                      },
                      {goTo: posizioneF,
                      label: "Continua"
                      }
                    ]
        
                  }
            )
        }
        
        
        //alert('cipolle')
        
        /*{
            askType: "mc",
            id: "_restartB",
            multyB: false,
            testi:[
              {
              type: "text",
              value: "<p></p>"
              },
              {
                type: "text",
                value: "<p>Ciao ben tornato come vuoi procedere?</p><p></p>"
                }
            ],
            buttons:[
              {goTo: "inixioo",
              label: "Ricomincia"
              },
              {goTo: oldConv.data.posizione_flow,
              label: "Continua"
              }
            ]

          }*/
       // selected('_q893j8tem')
    },[])

    useEffect(() => {
        //selected('_q893j8tem')

        chatBot({
          idRisposte:idResp,
          posizione:posizioneF === 'inixioo'  ? null : '_restartB',
          onMessage: (message) => {
              setMessage(messages => [...messages, message]);
              totopo()
            },
          onQuestion: options =>
            new Promise(resolve => {
              setOptions(options);
              setSelected(() => resolve);
              setRestartx(() => ()=>console.log('pollo1'));
            }).finally(() => {
              setRestart(false)  
              setOptions([]);
              setSelected(() => ()=>console.log('pollo2'));
            }),
          onQuestionNew: options =>
            new Promise(resolve => {
              setQuestions(options);
              totopo()
              setSelected(() => resolve);
              setRestartx(() => resolve);
            }).finally(() => {
               setRestart(false)  
               setQuestions(null);
               totopo()
              setSelected(() => noop);
              setRestartx(() => noop);
            }),
          onTyping: setTyping
        })(chatArr);
      }, [chatArr]);


     const totopo = () =>{
        //myRef.current.scrollTo(0, myRef.current.scrollHeight);
        myRef.current.scrollTo({
            top: myRef.current.scrollHeight,
            left: 0,
            behavior: 'smooth'
          });
      }


      const addToDinamicArr = (id) =>{
          let arrayys = [...dinamicSelect]
          let pos =  arrayys.indexOf(id)
          if(pos > -1){
            arrayys.splice(pos, 1);
               
            }else{
                arrayys.push(id)
            }
          
          setDinamicSelect(arrayys)
      }

      const isSeletecDinam = (id) =>{
          let pos =  dinamicSelect.indexOf(id)
          if(pos > -1){
              return true
          }else{
              return false
          }
      }

      const gestioneBC = () =>{
        
        let bg = {
          background:infoRoom.color,
          height:'100vh',
          overflow:'scroll',
        } 
        if(infoRoom.type === 'g'){
          bg = {
            background:'linear-gradient(0deg, '+infoRoom.colorFine +' 0%, '+infoRoom.color+' 100%)',
            height:'100vh',
            overflow:'scroll'
          }
        }
        if(infoRoom.type === 'i'){
          bg =  {
            backgroundImage :'url('+infoRoom.imgUrl+')',
            backgroundSize: 'cover',
            height:'100vh',
            overflow:'scroll',
            backgroundPosition: 'center center'
          }
        }
      
        return bg
      }

      

    return (
        <>
        <div style={{display:'none'}}>
        <Widget 
            preloader={null}
            ref={widgetApi}
            /*onFileSelect={(file) => {
            console.log('File changed: ', file)

            if (file) {
            file.progress(info => console.log('File progress: ', info.progress))
            file.done(info => console.log('File uploaded: ', info))
            }
            }}*/
            imagesOnly={(quetyons && quetyons.ancheFile) ? false : true}
            imageShrink="100x100"
            onChange={info =>  salvaImgFile(info)}
            publicKey='ce756ca8ae6d19b2bd9d' 
            id='file' tabs='file' 
            previewStep='true'/>
            </div>
        
        <div  ref={myRef} className=' inset-0 ' style={gestioneBC()}>
            

            
            <div className='m-auto p-5  relative' style={{ maxWidth:700,marginBottom: '80px'}}>
                {messages.map((x,i)=>{
                    if(x.my){
                        if(x.type === 'media'){
                            return(
                                <div style={{width:'100%'}}  className='mb-2 messEnter inline-block mt-5 mb-5'> 
                                    
                                    <div style={{background:'#000',color:'white',maxWidth:'85%'}} className='p-5 rounded-xl float-right inline-block'>
                                        <img style={{maxWidth:'50%'}} src={x.url}  alt=''/>
                                    </div>
                                </div>
                             )
                        }else{
                            return(
                                <div style={{width:'100%'}}  className='mb-2 messEnter inline-block mt-5 mb-5'> 
                                    
                                    <div style={{background:'#000',color:'white',maxWidth:'85%'}} className='p-5 rounded-xl float-right inline-block'>
                                        <div 
                                            dangerouslySetInnerHTML={{__html: x.value}}
                                        />
                                    </div>
                                </div>
                             )
                        }
                        
                    }else{
                        if(x.type === 'media'){
                            return(
                                <div  className='mb-2 items-end flex messEnter'> 
                                    <div className='mr-2' style={{width:40,height:40,background:'#ddd',borderRadius:30}}>
                                        <img style={{width:40,height:40,objectFit:'cover',borderRadius:30}} src={imgProfilo} alt=''/>
                                    </div>
                                    <div style={{}} className='inline-block'>
                                        <img style={{maxWidth:'100%'}} src={x.url}  alt=''/>
                                    </div>
                                </div>
                             )
                        }else if(x.type === 'gallery'){
                            if(i === 0){
                                return null
                            }else{
                                return(
                                    <div  className='mb-2 items-end flex messEnter'> 
                                    <div className='mr-2' style={{width:40,height:40,background:'#fff',borderRadius: 30}}>
                                        <img style={{width:40,height:40,objectFit:'cover',borderRadius:30}} src={imgProfilo} alt=''/>
                                    </div>
                                    <div style={{width:'50%',borderRadius:10,padding: 10, background: 'white',maxWidth:'85%'}} className='inline-block'>
                                
                                                <Slider {...{ dots: false, infinite: true, speed: 500, slidesToShow: 1, slidesToScroll: 1 }}>
                                                {x.gallery.map((imgg,i)=>{
                                                    return(
                                                        <div style={{display:'inline-block'}} key={'imgP'+i}>
                                                            <img alt='kl' style={{}} src={imgg} />
                                                        </div> 
                                                    )
                                                })}
                                               
                                                </Slider>
                                     </div>
                                               
                                    </div>
                                 )
                            }   
                            
                        }else if(x.type === 'video'){
                            if(i === 0){
                                return null
                            }else{
                                return(
                                    <div  className='mb-2 items-end flex messEnter'> 
                                    <div className='mr-2' style={{width:40,height:40,background:'#fff',borderRadius:30}}>
                                        <img style={{width:40,height:40,objectFit:'cover',borderRadius:30}} src={imgProfilo} alt=''/>
                                    </div>
                                        <div style={{background:'white',maxWidth:'85%'}} className='p-5 rounded-xl inline-block'>
                                            <video style={{}} width="320" height="240" controls>
                                                <source src={x.urlVideo} type="video/mp4"/>
                                            Your browser does not support the video tag.
                                            </video>
                                        </div>
                                    </div>
                                 )
                            }   
                            
                        }else if(x.type === 'wbHook'){
                            alert('ppppp')
                        } else{
                            if(x.value === '<p>sdsdsd</p>' ){
                                return null
                            }else{
                                return(
                                    <div  className='mb-2 items-end flex messEnter'> 
                                    
                                    <div className='mr-2' style={{width:40,height:40,background:'#fff',borderRadius:30}}>
                                        <img style={{width:40,height:40,objectFit:'cover',borderRadius:30}} src={imgProfilo} alt=''/>
                                    </div>
                                        <div style={{background:'white',maxWidth:'85%'}} className='p-5 rounded-xl inline-block'>
                                            <div 
                                                dangerouslySetInnerHTML={{__html: x.value}}
                                            />
                                        </div>
                                    </div>
                                 )
                            }   
                            
                        }
                        
                    }
                     
                })}
                {/* finto scrivere */}
                {typing ? (
                    <div className='mt-10'><Loader
                        type="Circles"
                        color="#ff719f"
                        height={20}
                        width={20}
                        timeout={3000} //3 secs
                    /></div>
                ) : null}
                
                <div className='mt-10'>
                    
                 {/*buttons */}  
                
                 {quetyons && quetyons.askType === 'imFile' ? (
                     <div style={{display: 'inline-block',padding: 15,background: '#ff719f', borderRadius: 4}} className=''>
                         <button style={{fontSize:16,color:'#fff',margin:0}} className='mt-2' onClick={() => widgetApi.current.openDialog()}>Seleziona file</button>
                     </div>    
                 ) :  null }
                 {quetyons && quetyons.askType === 'cma' ? (
                     <div style={{padding: 15,background: '#52525263', borderRadius: 4}} className=''>
                        <Select
                            className="basic-single"
                            classNamePrefix="select"
                            defaultValue={{}}
                            isClearable={true}
                            onChange={ripostaAutoCompUpdate}
                            name="color"
                            options={createArrayAutocomp(quetyons.listaAutoc)}
                            />
                            
                        {risposta.autoCompFly ? (
                           <button style={{background: 'rgb(255, 113, 159)', color: 'white',margin:0, marginTop: 10, width: '100%', borderRadius: 8,padding:10}} onClick={()=>salvaEinvia()} >Invia</button>   
                        ) : (
                            null
                        )}    
                       </div>
                 ) : null} 

                 {quetyons && quetyons.askType === 'sc' ? (
                     <div className='flex gap-px'>
                    {
                     quetyons.buttons.map(({ label, goTo }, i) => (
                 
                        <div style={{background:'#ff719f',width:45,color:'white'}} className='p-3 rounded-md mb-2 text-center'>
                           <button className='font-bold  uppercase' key={i} onClick={() => crateMessUser(label,goTo)}>
                               {label}
                           </button>
                       </div>
                       ))}
                       </div>
                 ) : null} 



                 {quetyons && quetyons.askType === 'mc' ? (
                     quetyons.buttons.map(({ label, goTo }, i) => (
                 
                        <div key={i} onClick={() => crateMessUser(label,goTo)} style={{background:'#ff719f',maxWidth:300,color:'white',display: 'inline-block',marginRight:10}} className='hover:opacity-80 p-3 rounded-md mb-2 text-center'>
                           <button style={{fontSize:11}} className='font-bold  uppercase'  >
                               {label}
                           </button>
                       </div>
                       ))
                 ) : null} 
                 {/* form */}
                 {quetyons && quetyons.askType === 'frm' ? (
                     <>
                     <div className='boxFormOpen'>
                         <div style={{width:'80%'}}>
                        <p className='mb-10 text-2xl'>Before we continue, please leave your contact details so we can get back to you...</p>
                        {quetyons.formQuestions.map(({ label ,type }, i) => (
                    
                            <div style={{color:'black'}} className='mb-2 text-center'>
                            {type === 'txt' ? (
                                <input style={{width: '100%', background: 'transparent', borderBottom: '1px solid #ddd'}} name={label} onChange={(e)=>updateRisposta(e)} type='text' placeholder={label} className='p-3 font-bold  uppercase' key={i} />

                            ) : (
                                <textarea style={{width: '100%', background: 'transparent', borderBottom: '1px solid #ddd'}}  name={label} onChange={(e)=>updateRisposta(e)} type='text' placeholder={label} className='p-3 font-bold  uppercase' key={i} />

                            )}   

                             
                        </div>
                        ))}
                        <button style={{background:'#ff719f',color:'white',width:'100%',padding:17,borderRadius:25,marginTop:80}} className='p-2 font-bold uppercase mt-10' onClick={()=>salvaForm()}>Salva</button>
                        </div>
                    </div>
                      </> 
                 ) : null}

                {/* testo */}
                 {quetyons && ( quetyons.askType === 'txt' || quetyons.askType === 'nm' )? (
                     <>
                     {quetyons.txtLong ? (
                         <div style={{position:'relative', background: '#9c9c9c94', /* display: flex; */ alignItems: 'center', padding: 17, borderRadius: 5, display: 'inline-block', position: 'relative'}} className=''>
                         <textarea style={{borderRadius: 5,width:250}} name={'textValue'} onChange={(e)=>updateRisposta(e)}  className='p-2' type={ quetyons.askType === 'txt' ? 'text' : 'number'} />
                         <button style={{background:'transparent',margin:0,position:'absolute',right:14}} className='p-2 font-bold uppercase mt-10' onClick={()=>salvaText()}>⮕</button>
                     </div>
                     ) : (
                        <div style={{position:'relative', background: '#9c9c9c94', /* display: flex; */ alignItems: 'center', padding: 17, borderRadius: 5, display: 'inline-block', position: 'relative'}} className=''>
                        <input style={{borderRadius: 5,width:250}} name={'textValue'} onChange={(e)=>updateRisposta(e)}  className='p-2' type={ quetyons.askType === 'txt' ? 'text' : 'number'} />
                        <button style={{background:'transparent',margin:0,position:'absolute',right:14}} className='p-2 font-bold uppercase mt-10' onClick={()=>salvaText()}>⮕</button>
                    </div>
                     )}
                     
                      </> 
                 ) : null}
                 {/* url */}
                 {quetyons && ( quetyons.askType === 'url' )? (
                     <>
                     <div style={{width: '100%',position:'relative', background: '#9c9c9c94', /* display: flex; */ alignItems: 'center', padding: 17, borderRadius: 5, display: 'inline-block', position: 'relative'}} className=''>
                        <input style={{width: '100%'}} name={'textValue'} onChange={(e)=>updateRisposta(e)}  className='p-2' type={'url'} />
                        <button style={{background:'transparent',margin:0,position:'absolute',right:14}} className='p-2 font-bold uppercase mt-10' onClick={()=>salvaText()}>⮕</button>
                     </div>   
                      </> 
                 ) : null}
                 {/* url */}
                 {quetyons && ( quetyons.askType === 'ad' )? (
                     <div style={{background:'white',width:'100%',borderRadius: 4}} className='p-2 inline-grid'>
                     <GooglePlacesAutocomplete
                        apiKey={"AIzaSyBHJQoJ6v1EAju_r79ShhN37ZdC_ACBm9g"}
                        placeholder="Type in an address"
                        selectProps={{
                            isClearable: true,
                            value: address,
                            onChange: (val) => {
                              setAddress(val)
                              ripostaLocations(val.value.description);
                            }
                          }}
                    />
                    {risposta.locationsFly ? (
                        <div className='flex items-center'>
                            <button style={{background: 'rgb(255, 113, 159)', color: 'white',margin:0, marginTop: 10, width: '100%', borderRadius: 8}} className='bottonInvio' onClick={()=>salvaLocation()}>Invia</button>
                        </div>
                    ) : null}
                      </div> 
                 ) : null}
                {/* telefono */}
                 {quetyons && quetyons.askType === 'pn' ? (
                      <div style={{background:'white'}} className='p-2 inline-grid'>
                      <div className='items-center'>
                        <PhoneInput
                            country={'it'}
                            onChange={phone => updateRispostaSingolo( phone )}
                            />
                        <button style={{background: 'rgb(255, 113, 159)', color: 'white',margin:0, marginTop: 10, width: '100%', borderRadius: 8}} className='bottonInvio' onClick={()=>salvaSingleValue()}>⮕</button>
                    </div>
                    </div>
                 ) : null}
                 {/* email */}
                 {quetyons && ( quetyons.askType === 'em' )? (
                     <>
                     <div style={{background:'white',width:'80%'}} className='p-2 inline-grid'>
                     <div className='flex items-center'>
                        <input autoFocus style={{border:'1px solid #ddd',borderRadius:20,width: '100%'}} name={'textValue'} onChange={(e)=>updateRisposta(e)}  className='p-2' type='email' />
                        <button style={{background:'#ddd',}} className='bottonInvio ' onClick={()=>salvaText(true)}>⮕</button>
                    </div>
                    </div>
                      </> 
                 ) : null}  
                 {/* rt */}
                 {quetyons && ( quetyons.askType === 'rt' )? (
                    <div style={{background:'white',borderRadius: 14}} className='p-2 inline-grid'>
                    <div className='flex items-center'>
                     <ReactStars
                        count={5}
                        onChange={updateRispostaReating}
                        size={24}
                        activeColor="#ffd700"
                    />
                        <button style={{background:'#ddd',}} className='bottonInvio ' onClick={()=>salvaRating()}>⮕</button>
                    </div>
                      </div> 
                 ) : null}  
                 {quetyons && ( quetyons.askType === 'dinamic' )? (
                    <div> 
                        <div style={{}} className='p-2 grid grid-cols-3'>
                            {JSON.parse(schemaRisposte.testDatoSave).map((card,i)=>{
                                return(
                                    <div key={'cardC'+i} onClick={()=>addToDinamicArr(card.id)} style={{background: isSeletecDinam(card.id) ? 'red' :'white'}} className='m-2 p-2 shadow-md rounded-md'>
                                        <img alt='k' src='https://firebasestorage.googleapis.com/v0/b/sssenior-e2b6d.appspot.com/o/images%2Fstrutture%2F5ebc164b71a5524b4ff723c9%2Fmelzo-9-scaled.jpg?alt=media&token=d017fe9f-88ea-4405-8759-6cdd36fedcaa' />
                                        <p className='text-lg font-bold'>Titolo</p>
                                        <p className='text-sm font-light'>{card.name}</p>
                                        <a rel='noreferrer' target='_blank' href='https://sssenior.com/it/structure/amati-live-borgomanero'>vedi pagina</a>
                                    </div>
                                )
                            })}
                        </div>
                        <button style={{background: 'rgb(255, 113, 159)', color: 'white',margin:0, marginTop: 10, width: '100%', borderRadius: 8}} className='bottonInvio' onClick={()=>salvaDinamycValue()}>Continua</button>
                    </div> 
                 ) : null}  


                
                   
                
                </div>
            </div>
            {/*<button><a target="_parent" href='https://sssenior.com/it/search/nursing-homes/Milano__Milan'>pppp</a></button>
            <div>
                <button onClick={()=>selected('_ylq85rums')}>test {posizioneF}</button>
                <br></br>
                <button onClick={()=>restartx('_ylq85rums')}>test yoooo {posizioneF}</button>
            </div>*/}
            {/*<div className='fixed p-5' style={{bottom:0}}>
                
                <button onClick={()=>console.log(messages)} className='p-5' >Show</button>
                
            </div>*/}
        </div>
        </>
    );
  }

  export default function Home() {

    let { id } = useParams();
    const [sturrura,setStruttura] = useState(null)
    const [infoRoom,setInfoRoom] = useState({})
    const [cookies, setCookie, removeCookie] = useCookies(['cookie-name']);
    
    const [valoriRisp, setValoriRisp] = useState({});

    const [idRespoder,setIdResponder] = useState(null);
    const [imgProf,setImgProf] = useState(null)
    const [posizioneF,setPosizioneF] = useState(0)
    const [vai,setVai] = useState(false)




    const iniaTutto = async () =>{
        

        try {
            
            var nuovaConvers = await axios.post('https://rivolta-form.herokuapp.com/api/v1/responde',{
                room:id
            })
            setIdResponder(nuovaConvers.data._id)
            
            //setCookie('pollo','cipollotto')
            //setCookie('room_'+id ,nuovaConvers.data._id, { path: '/' });
            localStorage.setItem("room_"+id, nuovaConvers.data._id);
            //setPosizioneF('inixioo')
            setVai(true)

            //alert('ok')
          } catch (error) {
            console.error(error);
          }
    }


    const caricaOldConv = async (id) =>{
        

        try {
            
            var oldConv = await axios.get('https://rivolta-form.herokuapp.com/api/v1/responde/show/'+id)
            
            console.log('mostro la vecchia convers');
            console.log(oldConv.data);
            //alert('sono qui ')
            //alert(oldConv.data.posizione_flow)
            setValoriRisp(oldConv.data)
            setPosizioneF(oldConv.data.posizione_flow ? oldConv.data.posizione_flow : 'inixioo')
            
            setVai(true)
            setIdResponder(oldConv.data._id)
           //alert(oldConv.data._id)
          } catch (error) {
            console.error(error);
            
          }
    }
    
    const azioniIniziali = async () =>{

    }

    useEffect(() => {
       
        
        
        //localStorage.setItem("key", "chiappe")

        //console.log(localStorage.getItem("key"));

        //console.log(cookies);
        //console.log(window.parent.document);
        //console.log(cookies['room_'+id]);
        if(!localStorage.getItem('room_'+id)){
            iniaTutto()

        }else{
            //console.log(cookies['room_'+id]);
            caricaOldConv(localStorage.getItem('room_'+id))
        }

        //console.log(cookies);
        axios.get('https://rivolta-form.herokuapp.com/api/v1/sroom/show/'+id)
        .then(function (response) {
            // handle success
            
            setImgProf( response.data.img ? response.data.img : 'https://avatarfiles.alphacoders.com/160/thumb-160200.png' )
            setStruttura(JSON.parse(response.data.structures))
            setInfoRoom(response.data.settings)
            
        })
        .catch(function (error) {
            // handle error
            console.log(error);
        })
        .then(function () {
            // always executed
        });

        

      }, []);

    return (
        <div className="App">
            {sturrura && vai ? (
                <Chat posizioneF={posizioneF} imgProfilo={imgProf} rispIniziali={valoriRisp} idResp={idRespoder} infoRoom={infoRoom} chatArr={sturrura.boxmess} />
            ) : null }
            
        </div>
    )}